/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  controls: [
    {
      key: 'leftAnchor',
      enabled: true,
      display: 'Slider minutes interval',
      placeholder: 'Enter number of minutes',
      type: 'number',
      defaultValue: 30,
    },
    {
      key: 'sliderDelayEtd',
      enabled: true,
      display: 'Slider delay for ETD play',
      placeholder: 'Enter number of minutes',
      type: 'number',
      defaultValue: 500,
    },
    {
      key: 'leftRight',
      enabled: false,
      display: 'Slider Type',
      type: 'slider',
      floor: 0,
      ceil: 100,
      placeholder: '',
      defaultValue: 6,
    },
    {
      key: 'enableDeveloperMode',
      enabled: true,
      display: 'Enable developer mode',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enableAlternateSlider',
      enabled: true,
      display: 'Enable Alternate Slider',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'leftRightRange',
      enabled: false,
      display: 'Range slider Type',
      type: 'rangeslider',
      floor: 0,
      ceil: 200,
      min: 15,
      max: 50,
      placeholder: '',
      defaultValue: 6,
    },
    {
      key: 'enableTestMode',
      enabled: true,
      display: 'Enable test mode',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enableAlternateColorScheme',
      enabled: true,
      display: 'Alternate color scheme',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'hideSliderStepButtons',
      enabled: true,
      display: 'Hide step buttons',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enableReportMode',
      enabled: true,
      display: 'Enable report mode',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enablePersonalMinimums',
      enabled: true,
      display: 'Personal minimums',
      type: 'toggle',
      placeholder: '',
      defaultValue: false,
    },
    {
      key: 'disableRouteValidation',
      enabled: true,
      display: 'Disable route validation',
      type: 'toggle',
      placeholder: '',
      defaultValue: false,
    },
    {
      key: 'testRouteTrend',
      enabled: true,
      display: 'Test route trend',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enableCloudBelowCig',
      enabled: true,
      display: 'Enable cloud below cig',
      type: 'toggle',
      placeholder: '',
      defaultValue: false,
    },
    {
      key: 'enableUpdateRequired',
      enabled: false,
      display: 'Enable update required',
      type: 'toggle',
      placeholder: '',
      defaultValue: true,
    },
    {
      key: 'enableSimulationUpdateRequired',
      enabled: true,
      display: 'Enable apple version simulation',
      type: 'toggle',
      placeholder: '',
      defaultValue: false,
    },
    {
      key: 'simulateUpdateRequiredValue',
      enabled: true,
      display: 'Simulate apple version',
      placeholder: 'Enter version like 4.4.7',
      type: 'text',
      defaultValue: '6.2.8',
    },
    {
      key: 'useLogarithmicScaleForCeiling',
      enabled: true,
      display: 'Logarithmic scale ceiling',
      type: 'toggle',
      placeholder: '',
      defaultValue: false,
    },
    {
      key: 'enableLoginFlow',
      enabled: true,
      display: 'Enable login flow',
      type: 'toggle',
      defaultValue: true,
    },
    {
      key: 'enableLeafletMap',
      enabled: true,
      display: 'Enable Leaflet map',
      type: 'toggle',
      defaultValue: false,
    },
    {
      key: 'enableRadarFeature',
      enabled: true,
      display: 'Enable Radar',
      type: 'toggle',
      defaultValue: true,
    },
    {
      key: 'enableSTRemovedupe',
      enabled: true,
      display: 'Remove Dupe Storm',
      type: 'toggle',
      defaultValue: true,
    },
    {
      key: 'stormTrackDuplicateRange',
      enabled: true,
      display: 'Dist in meter for storm duplicate check',
      placeholder: 'Enter number of meters',
      type: 'number',
      defaultValue: 5000,
    },
    {
      key: 'stormTrackZoomExtentRange',
      enabled: true,
      display: 'Zoom extent range for Storm',
      placeholder: 'Enter 3 comma seperated values',
      type: 'text',
      defaultValue: '15, 25, 50',
    },
    {
      key: 'stormTrackCtThresholds',
      enabled: true,
      display: 'CT range for Storm',
      placeholder: 'Enter 3 comma seperated values',
      type: 'text',
      defaultValue: '30000, 25000, 20000',
    },
    {
      key: 'apiVersionKey',
      enabled: true,
      display: 'Route API version',
      placeholder: 'Enter version',
      type: 'number',
      defaultValue: 3,
    },
  ],
};
